import React, { useEffect, useState } from 'react';
import { Modal, Table, Form } from 'react-bootstrap';
import Dropdown from 'react-bootstrap/Dropdown';
import { toast } from 'react-toastify';
import { downLoadFile, editTemplate, exportFile, getCategoryAll } from '../../controller';
import { requestHandler } from '../../helper';
import DeleteModal from '../DeleteModal';
import TemplateAdd from './TemplateAdd';
import TemplateEdit from './TemplateEdit';
import UserViewDetails from './UserViewDetails';
import Pagination from '../Pagination';

import SingleError from '../../helper/SingleError';

import { UrlValidate } from '../validate/urlValidate';

import ErrorFilter from '../../helper/errorFilter';
import PptModal from './info/PptModal';
import DocxModal from './info/DocxModal';
import XlsxModal from './info/XlsxModal';

function TemplateTable({ tempData, searchQuery, handleSearchChange, perPage, page, getAllTemplateData, setPage, onStatusChange, onCategoryIdChange, onFileTypeChange, onTemplateIdChange, allData, paginationValue }) {
    const requireField = ["file"];
    const [show, setShow] = useState(false);
    const [showDoc, setShowDoc] = useState(false);
    const [showXlsx, setShowXlsx] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState('all');
    const [selectedCategory, setSelectedCategory] = useState('all');
    const [selectedFileType, setSelectedFileType] = useState('all');
    const [selectedTemplateId, setSelectedTemplateId] = useState('all');
    const [file, setFile] = useState('');
    const [submitCount, setSubmitCount] = useState(0);
    const [errors, setErrors] = useState({});

    const [showPpt, setShowPpt] = useState(false);

    const handleClosePpt = () => setShowPpt(false);
    const handleShowPpt = () => setShowPpt(true);


    const [showDocx, setShowDocx] = useState(false);

    const handleCloseDocx = () => setShowDocx(false);
    const handleShowDocx = () => setShowDocx(true);


    const [showXlsxUpload, setShowXlsxUpload] = useState(false);

    const handleCloseXlsxUpload = () => setShowXlsxUpload(false);
    const handleShowXlsxUpload = () => setShowXlsxUpload(true);

    const [categoryData, setCategoryData] = useState([]);
    const handleShow = () => setShow(true);
    const handleShowDoc = () => setShowDoc(true);
    const handleShowXlsx = () => setShowXlsx(true);
    const handleClose = () => {
        setShow(false);
        setFile('');
        setErrors({});
    }
    const handleCloseDoc = () => {
        setShowDoc(false);
        setFile('');
        setErrors({});
    }
    const handleCloseXlsx = () => {
        setShowXlsx(false);
        setFile('');
        setErrors({});
    }
    const handleStatusSelect = (newStatus) => {
        setSelectedStatus(newStatus);
        // onStatusChange(newStatus); // Convert string to boolean
        onStatusChange(newStatus === 'all' ? '' : newStatus);
    };

    const handleCategoryIdSelect = (newCategoryId) => {
        setSelectedCategory(newCategoryId);
        onCategoryIdChange(newCategoryId === 'all' ? '' : newCategoryId);
    }
    const handleTeTemplateIdSelect = (newTemplateId) => {
        setSelectedTemplateId(newTemplateId);
        onTemplateIdChange(newTemplateId === 'all' ? '' : newTemplateId);
    }

    const handleFileTypeSelect = (newFileType) => {
        setSelectedFileType(newFileType);
        onFileTypeChange(newFileType === 'all' ? '' : newFileType);
    }
    const handleEditTemp = async (updatedData, itemId) => {
        await requestHandler(
            () => editTemplate(updatedData, itemId),  // Only pass the updated field
            null,
            (res) => {
                toast.success(res.message);
                onSuccessData();  // Handle success
            },
            () => { }  // Handle error (optional)
        );
    };

    const onSuccessData = () => {
        if (tempData.length === 1 && page > 1) {
            setPage(page - 1)
        } else {
            getAllTemplateData(perPage, page, searchQuery)
        }
    }

    const getCategoryData = async () => {
        await requestHandler(
            async () => await getCategoryAll(true),
            null,
            (res) => {
                const { category } = res.data;
                setCategoryData(category);
            },
            () => { }
        );
    };

    useEffect(() => {
        getCategoryData();
    }, []); //

    const handleDownload = async () => {
        try {
            const res = await exportFile(); // Call the updated function
            const url = URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.download = `TemplateManagement.xlsx`; // Set the file name and extension
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url); // Free up memory
            toast.success("Success! Your file has been downloaded");
        } catch (error) {
            console.error('Download error:', error);
            toast.error(error);
        }
    };

    // const handleUrlInputChange = (event) => {
    //     const url = event.target.value;
    //     setFile(url);

    //     // Validate immediately
    //     let validationErrors = UrlValidate({ file: url });
    //     validationErrors = ErrorFilter(validationErrors, requireField);

    //     // Update errors state correctly
    //     setErrors(prevErrors => {
    //         if (!validationErrors.file) {
    //             // Remove the error if it's now valid
    //             const { file, ...rest } = prevErrors;
    //             return rest;
    //         } else {
    //             // Set new error
    //             return { ...prevErrors, ...validationErrors };
    //         }
    //     });
    // };


    const handleUrlInputChange = (event) => {
        const url = event.target.value;
        setFile(url);

        // Validate URL for .xlsx (use fileExtension = '.xlsx')
        let validationErrors = UrlValidate({ file: url }, '.pptx');
        setErrors(prevErrors => ({
            ...prevErrors,
            file: validationErrors.file || ''
        }));
    };

    const handleDocxInputChange = (event) => {
        const url = event.target.value;
        setFile(url);

        // Validate URL for .docx (use fileExtension = '.docx')
        let validationErrors = UrlValidate({ file: url }, '.docx');
        setErrors(prevErrors => ({
            ...prevErrors,
            file: validationErrors.file || ''
        }));
    }

    const handleXlsxChange = (event) => {
        const url = event.target.value;
        setFile(url);

        // Validate URL for .xlsx (use fileExtension = '.xlsx')
        let validationErrors = UrlValidate({ file: url }, '.xlsx');
        setErrors(prevErrors => ({
            ...prevErrors,
            file: validationErrors.file || ''
        }));
    }

    const handleDownloadFile = async (fileType, extension) => {
        const data = {
            file: file, // Make sure 'file' is defined in your scope
            fileType: fileType,
            extension: extension
        };
        setSubmitCount(prevCount => prevCount + 1);
        const updatedValues = { ...data };

        // Validate the URL with the passed file extension (e.g., .xlsx or .pdf)
        let validationErrors = UrlValidate(updatedValues, '.pptx');

        validationErrors = ErrorFilter(validationErrors, requireField);
        setErrors(validationErrors);
        if (Object.keys(validationErrors).length === 0) {
            try {
                const res = await downLoadFile(data)
                const url = URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement("a");
                link.href = url;
                link.download = `${Date.now()}.${fileType}`; // Set the file name and extension
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url); // Free up memory
                toast.success("Success! Your file has been downloaded");
            } catch (error) {
                toast.error("File not found",);
            }
        }

    };

    const handleDownloadFileXlsx = async (fileType, extension) => {
        const data = {
            file: file, // Make sure 'file' is defined in your scope
            fileType: fileType,
            extension: extension
        };
        setSubmitCount(prevCount => prevCount + 1);
        const updatedValues = { ...data };

        // Validate the URL with the passed file extension (e.g., .xlsx or .pdf)
        let validationErrors = UrlValidate(updatedValues, '.xlsx');

        validationErrors = ErrorFilter(validationErrors, requireField);
        setErrors(validationErrors);
        if (Object.keys(validationErrors).length === 0) {
            try {
                const res = await downLoadFile(data)
                const url = URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement("a");
                link.href = url;
                link.download = `${Date.now()}.${fileType}`; // Set the file name and extension
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url); // Free up memory
                toast.success("Success! Your file has been downloaded");
            } catch (error) {
                toast.error("File not found",);
            }
        }

    };
    const handleDownloadFileDocx = async (fileType, extension) => {
        const data = {
            file: file, // Make sure 'file' is defined in your scope
            fileType: fileType,
            extension: extension
        };
        setSubmitCount(prevCount => prevCount + 1);
        const updatedValues = { ...data };

        // Validate the URL with the passed file extension (e.g., .xlsx or .pdf)
        let validationErrors = UrlValidate(updatedValues, '.docx');

        validationErrors = ErrorFilter(validationErrors, requireField);
        setErrors(validationErrors);
        if (Object.keys(validationErrors).length === 0) {
            try {
                const res = await downLoadFile(data)
                const url = URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement("a");
                link.href = url;
                link.download = `${Date.now()}.${fileType}`; // Set the file name and extension
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url); // Free up memory
                toast.success("Success! Your file has been downloaded");
            } catch (error) {
                toast.error("File not found",);
            }
        }

    };
    const [fileExtension, setFileExtension] = useState('');

    // Check file extension whenever file URL changes
    useEffect(() => {
        if (file) {
            const extension = file.split('.').pop().toLowerCase();
            setFileExtension(extension);
        }
    }, [file]);

    return (
        <>
            <div className="card-header border-0 p-0 pb-3">
                <div className='row g-4'>
                    <div className="col-12 col-xl-4">
                        <div className='form-control search-bar py-0 px-0'>
                            <div className='search-box'>
                                <img src="./images/png/seach-icon.png" width={13.81} height={13.81} alt="" />
                            </div>
                            <input type="text" className='form-control rounded-start-0 border-0' placeholder='Search here' value={searchQuery} onChange={handleSearchChange} />
                        </div>
                    </div>

                    <div className="col-12 col-xl-8">
                        <div className='d-flex flex-wrap justify-content-end align-items-center gap-3'>
                            <Dropdown className='status-btn'>
                                <Dropdown.Toggle variant="success" className={selectedTemplateId !== 'all' ? '' : 'text_light'} id="dropdown-basic">
                                    {selectedTemplateId ?
                                        allData.find(template => template._id === selectedTemplateId)?.name || 'Template'
                                        : 'Template'}

                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={() => handleTeTemplateIdSelect('all')} className={selectedTemplateId === '' ? 'selected-status' : ''} >All</Dropdown.Item>
                                    {allData.map((temp, index) => {
                                        return (
                                            <Dropdown.Item
                                                key={index} onClick={() => handleTeTemplateIdSelect(temp._id)} className={selectedTemplateId === temp._id ? 'selected-status' : ''}>
                                                {temp.name}
                                            </Dropdown.Item>
                                        )
                                    })}

                                </Dropdown.Menu>
                            </Dropdown>

                            <Dropdown className='status-btn'>
                                <Dropdown.Toggle variant="success" id="dropdown-basic" className={selectedCategory !== 'all' ? '' : 'text_light'}>
                                    {selectedCategory ?
                                        categoryData.find(cat => cat._id === selectedCategory)?.name || 'Category'
                                        : 'Category'}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={() => handleCategoryIdSelect('all')} className={selectedCategory === 'all' ? 'selected-status' : ''}>All</Dropdown.Item>
                                    {categoryData.map((category, index) => (
                                        <Dropdown.Item
                                            key={index}
                                            onClick={() => {
                                                handleCategoryIdSelect(category._id); // Assuming category.id is available
                                                // Set selected category name
                                            }}
                                            className={selectedCategory === category._id ? 'selected-status' : ''}
                                        >
                                            {category.name}
                                        </Dropdown.Item>
                                    ))}
                                </Dropdown.Menu>
                            </Dropdown>

                            <Dropdown className='status-btn'>
                                <Dropdown.Toggle variant="success" id="dropdown-basic" className={selectedFileType !== 'all' ? '' : 'text_light'}>
                                    {selectedFileType === 'all' ? 'Select Type' : selectedFileType.toUpperCase()}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={() => handleFileTypeSelect('all')} className={selectedFileType === 'all' ? 'selected-status' : ''}>All</Dropdown.Item>
                                    <Dropdown.Item onClick={() => handleFileTypeSelect('pptx')} className={selectedFileType === 'pptx' ? 'selected-status' : ''}>Ppt</Dropdown.Item>
                                    <Dropdown.Item onClick={() => handleFileTypeSelect('ejs')} className={selectedFileType === 'ejs' ? 'selected-status' : ''}>Pdf</Dropdown.Item>
                                    {/* <Dropdown.Item href="#/action-2">xlsx</Dropdown.Item> */}
                                    <Dropdown.Item onClick={() => handleFileTypeSelect('docx')} className={selectedFileType === 'docx' ? 'selected-status' : ''}>Doc</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                            <Dropdown className='status-btn'>
                                <Dropdown.Toggle variant="success" id="dropdown-basic" className={selectedStatus !== 'all' ? '' : 'text_light'}>
                                    {selectedStatus === 'all' ? 'Select Type' : selectedStatus === 'false' ? 'Deactive' : 'Active'}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={() => handleStatusSelect('all')} className={selectedStatus === 'all' ? 'selected-status' : ''}>All</Dropdown.Item>
                                    <Dropdown.Item onClick={() => handleStatusSelect('true')} className={selectedStatus === 'true' ? 'selected-status' : ''}>Active</Dropdown.Item>
                                    <Dropdown.Item onClick={() => handleStatusSelect('false')} className={selectedStatus === 'false' ? 'selected-status' : ''}>Deactive</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                            <TemplateAdd getAllTemplateData={getAllTemplateData} categoryData={categoryData} />
                            <button className='add-btn' onClick={() => handleDownload()}>
                                <p className='m-0'>Export file</p>
                            </button>
                            <button className='add-btn' onClick={handleShow}>
                                <p className='m-0'>Upload pptx</p>
                            </button>
                            <button className='add-btn' onClick={handleShowDoc}>
                                <p className='m-0'>Upload docx</p>
                            </button>
                            <button className='add-btn' onClick={handleShowXlsx}>
                                <p className='m-0'>Upload xlsx</p>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className='overflow-auto-lg'>
                <Table striped hover>
                    <thead>
                        <tr>
                            <th>No </th>
                            <th className='text-center'>Template</th>
                            <th className='text-center'>Category</th>
                            {/* <th className='text-center'>Type</th> */}
                            <th className='text-center'>Status</th>
                            <th style={{ width: '180px', }} className='text-center'>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tempData.length > 0 ? (
                            tempData.map((item, index) => {
                                return (
                                    <tr key={index}>
                                        <td>{(page - 1) * perPage + index + 1}</td>
                                        <td className='text-center'>
                                            <div className='d-flex justify-content-center'>
                                                <td className="text_primary">
                                                    {item?.name}
                                                </td>
                                            </div>
                                        </td>
                                        <td>
                                            <div className='d-flex justify-content-center'>
                                                <td className="text_primary">
                                                    {item.categoryId.map((cat, index) => {
                                                        return (
                                                            cat.name
                                                        )
                                                    })}
                                                </td>
                                            </div>
                                        </td>

                                        <td className='text-center'>
                                            <div className='d-flex justify-content-center'>
                                                <Dropdown className='status-btn active all-drop'>
                                                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                                                        {item.status ? 'Active' : 'Deactive'}
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu>
                                                        <Dropdown.Item onClick={() => handleEditTemp({ status: true }, item._id)} className={item.status === true ? 'selected-status' : ''}>Active</Dropdown.Item>
                                                        <Dropdown.Item onClick={() => handleEditTemp({ status: false }, item._id)} className={item.status === false ? 'selected-status' : ''}>Deactive</Dropdown.Item>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </div>
                                        </td>
                                        <td style={{ width: '180px', }} >
                                            <div className='d-flex justify-content-center align-items-center gap-2 actions-image'>
                                                <div className="d-flex justify-content-center align-items-center gap-2 actions-image">
                                                    <UserViewDetails formData={item} />
                                                    <TemplateEdit id={item._id} tempData={tempData} getAllTemplateData={getAllTemplateData} categoryData={categoryData} />
                                                    <DeleteModal title={"Template Details"} id={item._id} endPoint={`/template/delete`} onSuccess={onSuccessData} />
                                                </div>

                                            </div>
                                        </td>
                                    </tr>
                                )

                            })
                        ) : (
                            <tr>
                                <td colSpan={7} className='text-center py-3'>
                                    No data available
                                </td>
                            </tr>
                        )}

                    </tbody>
                </Table>
                <div className='d-flex justify-content-center mt-4'>
                    {paginationValue > 1 && (
                        <Pagination
                            currentPage={page}
                            totalPages={paginationValue}
                            onPageChange={(newPage) => {
                                setPage(newPage);
                            }} />
                    )}
                </div>
            </div>


            <Modal className='modal-main' show={show} centered size='md' onHide={handleClose}>
                <Modal.Body>
                    <Modal.Title>
                        <div className="row justify-content-center">
                            <div className="col-11 col-8">
                                <h2>Upload Pptx</h2>
                            </div>
                        </div>
                    </Modal.Title>

                    <div className='modal-form'>
                        <Form>
                            {/* Template Name Input */}
                            <Form.Group className="mb-3">
                                <Form.Label>Pptx Url</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter pptx url"
                                    value={file}
                                    onChange={handleUrlInputChange}
                                    name="file"
                                    required
                                />
                                <SingleError error={errors?.file} />
                            </Form.Group>

                            {/* Conditionally render file buttons based on file extension */}
                            <div className='row row-cols-3 select-format-file'>

                                <>
                                    <div className="col"
                                        onClick={() => handleDownloadFile('ejs', fileExtension)}
                                        style={{ cursor: 'pointer' }}>
                                        <div className='d-flex justify-content-center'>
                                            <div>
                                                <img src="../images/png/pdf.png" width={37.26} height={47.61} alt="" />
                                                <p>pdf</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col"
                                        onClick={() => handleDownloadFile('docx', fileExtension)}
                                        style={{ cursor: 'pointer' }}>
                                        <div className='d-flex justify-content-center'>
                                            <div>
                                                <img src="../images/png/docx.png" width={37.26} height={47.61} alt="" />
                                                <p>docx</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col"
                                        onClick={() => handleDownloadFile('xlsx', fileExtension)}
                                        style={{ cursor: 'pointer' }}>
                                        <div className='d-flex justify-content-center'>
                                            <div>
                                                <img src="../images/png/xlsx.png" width={47.85} height={47.85} alt="" />
                                                <p>xlsx</p>
                                            </div>
                                        </div>
                                    </div>
                                </>

                                {/* 
                                {fileExtension === 'docx' && (
                                    <div className="col"
                                        onClick={() => handleDownloadFile('ejs', fileExtension)}
                                        style={{ cursor: 'pointer' }}>
                                        <div className='d-flex justify-content-center'>
                                            <div>
                                                <img src="../images/png/pdf.png" width={37.26} height={47.61} alt="" />
                                                <p>pdf</p>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {fileExtension === 'xlsx' && (
                                    <div className="col"
                                        onClick={() => handleDownloadFile('ejs', fileExtension)}
                                        style={{ cursor: 'pointer' }}>
                                        <div className='d-flex justify-content-center'>
                                            <div>
                                                <img src="../images/png/pdf.png" width={37.26} height={47.61} alt="" />
                                                <p>pdf</p>
                                            </div>
                                        </div>
                                    </div>
                                )} */}

                                {/* {fileExtension === 'ejs' && (
                                    <p>No format buttons available for .ejs</p>
                                )} */}
                            </div>

                            <div className='d-md-flex align-items-center gap-3 mt-4'>
                                <button className='cancel-btn' onClick={handleClose} type='button'>Cancel</button>
                            </div>
                            <div className='d-flex align-items-center justify-content-center gap-1 mt-4 cursor-pointer' onClick={handleShowPpt}>
                                How to Upload?
                                <img src="/images/svg/info.svg" width={20} alt="" />
                            </div>
                        </Form>
                    </div>
                </Modal.Body>
            </Modal>



            <Modal className='modal-main' show={showDoc} centered size='md' onHide={handleCloseDoc}>
                <Modal.Body>
                    <Modal.Title>
                        <div className="row justify-content-center">
                            <div className="col-11 col-8">
                                <h2>Upload Docx</h2>
                            </div>
                        </div>
                    </Modal.Title>

                    <div className='modal-form'>
                        <Form>
                            {/* Template Name Input */}
                            <Form.Group className="mb-3">
                                <Form.Label>Docx Url</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter docx url"
                                    value={file}
                                    onChange={handleDocxInputChange}
                                    name="file"
                                    required
                                />
                                <SingleError error={errors?.file} />
                            </Form.Group>

                            {/* Conditionally render file buttons based on file extension */}
                            <div className='row select-format-file'>
                                <div className="col-12"
                                    onClick={() => handleDownloadFileDocx('ejs', fileExtension)}
                                    style={{ cursor: 'pointer' }}>
                                    <div className='d-flex justify-content-center'>
                                        <div>
                                            <img src="../images/png/pdf.png" width={37.26} height={47.61} alt="" />
                                            <p>pdf</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='d-md-flex align-items-center gap-3 mt-4'>
                                <button className='cancel-btn' onClick={handleCloseDoc} type='button'>Cancel</button>
                            </div>
                            <div className='d-flex align-items-center justify-content-center gap-1 mt-4 cursor-pointer' onClick={handleShowDocx}>
                                How to Upload?
                                <img src="/images/svg/info.svg" width={20} alt="" />
                            </div>
                        </Form>
                    </div>
                </Modal.Body>
            </Modal>


            <Modal className='modal-main' show={showXlsx} centered size='md' onHide={handleCloseXlsx}>
                <Modal.Body>
                    <Modal.Title>
                        <div className="row justify-content-center">
                            <div className="col-11 col-8">
                                <h2>Upload Xlsx</h2>
                            </div>
                        </div>
                    </Modal.Title>

                    <div className='modal-form'>
                        <Form>
                            {/* Template Name Input */}
                            <Form.Group className="mb-3">
                                <Form.Label>Xlsx Url</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter xlsx url"
                                    value={file}
                                    onChange={handleXlsxChange}
                                    name="file"
                                    required
                                />
                                <SingleError error={errors?.file} />
                            </Form.Group>

                            {/* Conditionally render file buttons based on file extension */}
                            <div className='row select-format-file'>
                                <div className="col-12"
                                    onClick={() => handleDownloadFileXlsx('ejs', fileExtension)}
                                    style={{ cursor: 'pointer' }}>
                                    <div className='d-flex justify-content-center'>
                                        <div>
                                            <img src="../images/png/pdf.png" width={37.26} height={47.61} alt="" />
                                            <p>pdf</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='d-md-flex align-items-center gap-3 mt-4'>
                                <button className='cancel-btn' onClick={handleCloseXlsx} type='button'>Cancel</button>
                            </div>
                            <div className='d-flex align-items-center justify-content-center gap-1 mt-4 cursor-pointer' onClick={handleShowXlsxUpload}>
                                How to Upload?
                                <img src="/images/svg/info.svg" width={20} alt="" />
                            </div>
                        </Form>
                    </div>
                </Modal.Body>
            </Modal>
            <PptModal show={showPpt} handleClose={handleClosePpt} />
            <DocxModal show={showDocx} handleClose={handleCloseDocx} />
            <XlsxModal show={showXlsxUpload} handleClose={handleCloseXlsxUpload} />


        </>
    )
}

export default TemplateTable